module.exports = __webpack_public_path__ + "media/9s.jpg";